var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-loading"},[_c('div',{staticClass:"body-loading"},[_c('div',{staticClass:"loading-text"},[_c('i',{staticClass:"el-icon-loading"})])])])
}]

export { render, staticRenderFns }